import React, { useState } from "react";
import Label from "./Label";
import Input from "./Input";
import { cn } from "../lib/utils";
import { firestore } from "../firebase";
import { collection, addDoc } from "firebase/firestore";
import { toast } from "sonner";
import { IconLoader } from "@tabler/icons-react";
import { motion } from "framer-motion";
type Props = {};
const initial = {
	subject: "",
	nameSurname: "",
	email: "",
	description: "",
};
const DeleteMyDataForm = (props: Props) => {
	const [loading, setLoading] = useState(false);
	const [formValues, setFormValues] = useState(initial);

	const handleSubmit = async () => {
		if (!formValues.email) {
			toast("Enter your email!", {
				description: "Please fill email field to delete your data!",
			});
			return;
		}
		setLoading(true);
		try {
			var deviceId = localStorage.getItem("sftdvcid");
			const contactFormCollection = collection(firestore, "contactForm"); // Firestore collection
			const documentData = {
				...formValues,
				createdAt: new Date().toISOString(),
				deviceId,
			};

			const result = await addDoc(contactFormCollection, documentData);
			if (result.id) {
				toast("We received your request!", {
					description: "We will reply to you via the email you entered as soon as possible",
				});
			}
		} catch (error: any) {
			toast("Something is not right!", {
				description: "An error occured while saving your message, please refresh the page and try again.",
			});
		}
		setFormValues(initial);
		setLoading(false);
	};
	return (
		<motion.div
			initial={{
				opacity: 0,
				scale: 0,
			}}
			whileInView={{
				opacity: 1,
				scale: 1,
				transition: {
					delay: 0.5,
					duration: 0.5,
					ease: "easeInOut",
				},
			}}
			className='max-w-md w-11/12 lg:w-full mx-auto rounded-2xl p-4 md:p-8 shadow-black/50 shadow-2xl bg-gradient-to-br from-slate-800 via-slate-950 to-slate-800'>
			<h2 className='font-medium text-xl text-neutral-200 text-center'>
				Fill out the input below to send a data delete request.
			</h2>
			<div className='my-8 space-y-5'>
				<LabelInputContainer>
					<Label htmlFor='email'>We're sorry to see you go.</Label>
					<Input
						id='email'
						placeholder='Enter your email and we delete your data'
						type='email'
						onChange={(e) => {
							setFormValues({ ...formValues, email: e.currentTarget.value });
						}}
					/>
				</LabelInputContainer>
				<button
					onClick={handleSubmit}
					type='button'
					disabled={loading}
					className='inline-flex w-full h-12 animate-shimmer items-center justify-center rounded-lg bg-[linear-gradient(110deg,#000103,45%,#1e2631,55%,#000103)] bg-[length:200%_100%] px-6 font-medium text-white transition-colors focus:outline-none focus:ring focus:ring-slate-800'>
					{!loading ? "Submit" : <IconLoader className='animate-spin' />}
				</button>
			</div>
		</motion.div>
	);
};

const LabelInputContainer = ({ children, className }: { children: React.ReactNode; className?: string }) => {
	return <div className={cn("flex flex-col space-y-2 w-full", className)}>{children}</div>;
};

export default DeleteMyDataForm;
